import { Controller, MobileContextMenu } from '@tencent/workbench';
import { PasteFeature } from './paste-feature';
import { MOBILE_CONTEXTMENU_ITEMS, config } from './config';
@Controller({
    mobileContextMenuItems: MOBILE_CONTEXTMENU_ITEMS,
})
export class PasteController {
    constructor(private readonly feature: PasteFeature) {
    }

    @MobileContextMenu(config.name, 'onClick')
    public onClick() {
        this.feature.paste();
    }
}

